import { create } from "zustand/react";
import { devtools } from "zustand/middleware";
import { IStepData } from "./model";

interface IAssessmentStore {
  assessmentId?: number;
  setAssessmentId: (id?: number) => void;

  stepId?: string;
  setStepId: (id?: string) => void;

  stepData?: IStepData;
  setStepData: (stepData?: IStepData) => void;

  showInitialStep: boolean;
  setShowInitialStep: (showInitialStep: boolean) => void;

  resetStore: () => void;
}

export const useAssessmentStore = create<IAssessmentStore>()(
  devtools(
    (set) => ({
      assessmentId: null,
      setAssessmentId: (id) => set({ assessmentId: id }, false, "setAssessmentId"),
      stepId: null,
      setStepId: (id) => set({ stepId: id }, false, "setStepId"),

      stepData: null,
      setStepData: (stepData: IStepData | null) => set({ stepData }, false, "setStepData"),

      showInitialStep: false,
      setShowInitialStep: (showInitialStep) => set({ showInitialStep }, false, "setShowInitialStep"),

      resetStore: () =>
        set({ assessmentId: null, stepId: null, showInitialStep: false, stepData: null }, false, "resetStore"),
    }),
    { name: "AssessmentStore" },
  ),
);
